import React, { useContext, useEffect, useState } from "react";
import {
  Grid,
  Box,
  Container,
  CircularProgress,
  Typography,
  Button,
  FormControl,
  makeStyles,
  FormHelperText,
  MenuItem,
  InputLabel,
  Select,
  Card,
  CardContent,
  Paper,
  Divider,
} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";
import { Form, Formik } from "formik";
import * as yep from "yup";
import axios from "axios";
import { toast } from "react-toastify";
// import ButtonCircularProgress from "src/component/ButtonCircularProgress"
// import Page from "src/component/Page";
import { useLocation } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';
import Axios from "axios";
import PageTitle from "../../components/PageTitle";

// import { useAtStart } from "react-scroll-to-bottom";
import ApiConfig from "../../config/ApiConfig";
import { DropzoneArea } from "material-ui-dropzone";
import ReactGoogleAutocomplete from "react-google-autocomplete";
import CircularProgressWithBackdrop from "../../components/Loader/loader";
import { menuProps } from "../../utils";

const useStyles = makeStyles((theme) => ({
  main: {
    width: "100%",
    display: "flex",
    flexDirection: 'column',
    gap: '24px',
    justifyContent: "center",
    alignItems: 'center',
    padding: '24px',
  },
  editInput: {
    position: "absolute",
    zIndex: "1000",
    opacity: "0",
    cursor: "pointer",
    right: "0",
    top: "0",
    height: "100%",
    fontSize: "24px",
    width: "100%",
  },
  imgUploadDiv: {
    height: "200px",
    width: "200px",
    position: "relative",
    overflow: "hidden",
  },
  tableButton: {
    borderRadius: "12px",
    background: "linear-gradient(135deg, #00AFEE 0%, #0099CC 100%)",
    width: "100%",
    maxWidth: '200px',
    height: '48px',
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'none',
    boxShadow: '0 4px 12px rgba(0, 175, 238, 0.3)',
    '&:hover': {
      background: "linear-gradient(135deg, #0099CC 0%, #0088BB 100%)",
      boxShadow: '0 6px 16px rgba(0, 175, 238, 0.4)',
    }
  },
  TitleBox: {
    marginTop: "16px",
    fontSize: "28px",
    fontWeight: 700,
    lineHeight: 1.4,
    color: "#2c3e50",
    marginBottom: "24px",
    textAlign: "center",
    background: "linear-gradient(135deg, #00AFEE 0%, #0099CC 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
  },
  DropzoneArea: {
    background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
    border: "2px dashed #00AFEE",
    borderRadius: "16px",
    transition: "all 0.3s ease",
    '&:hover': {
      borderColor: "#0099CC",
      background: "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
    }
  },
  TextBox: {
    background: "white",
    borderRadius: "12px",
    '& .MuiOutlinedInput-root': {
      borderRadius: "12px",
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: "#00AFEE",
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: "#00AFEE",
        borderWidth: "2px",
      }
    }
  },
  colorbox1: {
    width: '100%',
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    "& .MuiGrid-container": {
      display: "block !important",
    },
    "& .MuiGrid-grid-xs-4": {
      maxWidth: "100%",
    },
    "& .MuiDropzoneArea-textContainer": {
      display: "none",
    },
    "& .MuiDropzonePreviewList-image": {
      height: "100%",
      maxHeight: '300px',
      borderRadius: "12px",
    },
    "& .MuiDropzonePreviewList-removeButton": {
      display: "block",
      top: "16px",
      right: "16px",
      width: "32px",
      height: "32px",
      opacity: 0.8,
      position: "absolute",
      transition: ".3s ease",
      backgroundColor: "rgba(255, 255, 255, 0.9)",
      borderRadius: "50%",
      '&:hover': {
        opacity: 1,
        backgroundColor: "rgba(255, 0, 0, 0.8)",
      }
    },
    "& .MuiDropzoneArea-root": {
      border: '2px dashed #00AFEE',
      borderRadius: '16px',
      background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
      transition: "all 0.3s ease",
      '&:hover': {
        borderColor: "#0099CC",
        background: "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
      }
    }
  },
  selectTag: {
    color: "#6c757d",
    '& .MuiSelect-outlined.MuiSelect-outlined': {
      color: '#2c3e50'
    },
  },
  colorbox: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    "& .MuiGrid-container": {
      display: "block !important",
    },
    "& .MuiGrid-grid-xs-4": {
      maxWidth: "100%",
    },
    "& .MuiDropzoneArea-textContainer": {
      display: "block !important",
      paddingTop: "55px",
      color: "#6c757d",
    },
    "& .MuiDropzonePreviewList-removeButton": {
      display: "block",
    },
    "& .MuiDropzonePreviewList-removeButton": {
      top: "16px",
      right: "16px",
      width: "32px",
      height: "32px",
      opacity: 0.8,
      position: "absolute",
      transition: ".3s ease",
      backgroundColor: "rgba(255, 255, 255, 0.9)",
      borderRadius: "50%",
      '&:hover': {
        opacity: 1,
        backgroundColor: "rgba(255, 0, 0, 0.8)",
      }
    },
    "& .MuiDropzoneArea-root": {
      border: '2px dashed #00AFEE',
      borderRadius: '16px',
      background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
      transition: "all 0.3s ease",
      '&:hover': {
        borderColor: "#0099CC",
        background: "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
      }
    }
  },
  formCard: {
    borderRadius: "16px",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
    border: "1px solid rgba(0, 175, 238, 0.1)",
    background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
    marginBottom: "24px",
  },
  formCardContent: {
    padding: "32px",
  },
  sectionTitle: {
    fontSize: "20px",
    fontWeight: 600,
    color: "#2c3e50",
    marginBottom: "24px",
    paddingBottom: "12px",
    borderBottom: "3px solid #00AFEE",
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  label: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#2c3e50",
    marginBottom: "8px",
    display: "block",
  },
  faq: {
    marginBottom: "16px",
  },
  select: {
    '& .MuiOutlinedInput-root': {
      borderRadius: "12px",
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: "#00AFEE",
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: "#00AFEE",
        borderWidth: "2px",
      }
    }
  },
  imageUploadCard: {
    borderRadius: "16px",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
    border: "1px solid rgba(0, 175, 238, 0.1)",
    background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
    padding: "32px",
    textAlign: "center",
  },
  buttonContainer: {
    marginTop: "32px",
    display: "flex",
    gap: "16px",
    justifyContent: "center",
    flexWrap: "wrap",
  },
}));
function Addtester() {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();


  const [loader, setLoader] = useState(false);
  const [loader1, setLoader1] = useState(false);
  const [countryCode, setCountryCode] = useState("");
  const [states, setStates] = useState([]);
  const [showStates, setShowStates] = useState();
  const [citystate, setCityState] = useState([]);
  const [hoID, setHoID] = useState();
  const [bmID, setBmID] = useState();
  const [bhID, setBhID] = useState();


  const [headOfficer, setHeadOfficer] = useState([]);
  const [branchHeadList, setBranchHeadList] = useState([]);
  const [branchManagerList, setBranchManagerList] = useState([]);
  const [image, setImage] = useState('');
  const [imgLink, setImgLink] = useState('')
  const [userLocation, setUserLocation] = useState('')


  const formInitialSchema = {
    fullName: "",
    email: "",
    phoneNumber: '',
    state: '',
    city: '',
    ho: '',
    branchManager: '',
    branchHead: '',
    block: '',
    userName: '',
    location:''
  };

  const handleDrop = (files) => {
    if (files.length > 0) {
      const reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = (e) => {
        setImage(e.target.result);
        uploadIMG(e.target.result)
      };
    }
  };
  const uploadIMG = async (values) => {
    const data = values.split(',')
    const splitDate = data[1]
    setLoader1(true)
    try {
      const res = await Axios({
        method: "POST",
        url: ApiConfig.base,

        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
        },
        data: [values],
      });

      if (res.data.status === 200) {
        toast.success(res?.data?.message);
        setLoader1(false)
        setImgLink(res?.data?.data[0])

      } else {
        setLoader1(false)
      }
    } catch (error) {
      setLoader1(false)
    }
  };
  function generatePassword(length) {
    const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+";

    let password = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      password += charset[randomIndex];
    }

    return password;
  }
  const generatedPassword = generatePassword(8);


  const handleFormSubmit = async (values) => {
    setLoader(true)
    try {
      const res = await Axios({
        method: "POST",
        url: ApiConfig.addTester,

        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
        },
        params: {
          role: 'ADMIN',
          username: `${window.localStorage.getItem("email")}`
        },
        data: {
          city: values.city,
          email: values.email,
          fullName: values.fullName,
          block: values.block,
          phoneNo: values.phoneNumber,
          location: userLocation,
          profileImage: imgLink,
          roleStatus: "USER",
          state: values.state,
          password: "Mobiloitte@1",
          userName: values.userName,
          branchHeadId: bhID,
          branchManagerId: bmID,
          headOfficerId: hoID,
        },
      });

      if (res.data.status === 200) {
        toast.success(res.data.message);
        // history.push('/app/user-list')
        history.push({ pathname: "/app/user-list", state: "USER" })
        setLoader(false)
      } else if (res.data.status === 205) {
        setLoader(false)
        toast.error(res.data.message);
      }
    } catch (error) {
      setLoader(false)
    }
  };

  const validationSchema = yep.object().shape({
    fullName: yep
      .string()
      .required("Please Enter Full Name.")
      .max(60, "Full Name must be at most 60 characters.")
      .matches(
        /^[a-zA-Z]+(?: [a-zA-Z]+)*$/,
        "Full Name can only contain letters."
      ),
      email: yep
      .string()
      .email("Please enter a valid email address.")
      .required("Please enter your email address.")
      .max(255, "Email address should be less than 255 characters.")
      .matches(
      /^(?!.*\.\.)(?!.*[@.]$)[a-zA-Z0-9][a-zA-Z0-9._+-]{0,252}@[a-zA-Z0-9-]{2,63}(\.[a-zA-Z]{2,63}){1,2}$/,
        "Please enter a valid email address."
      ),
      phoneNumber: yep
      .string()
      .required("Please Enter Phone Number.")
      .min(8, "Enter a valid Phone Number")
      .max(16, "Enter a valid Phone Number"),
    state: yep.string()
      .required('State is required.'),
    city: yep.string()
      .required('City is required.'),
    ho: yep.string()
      .required('Head Officer is required.'),
    branchManager: yep.string()
      .required('Regional Manager is required.'),
    branchHead: yep.string()
      .required('Area Manager is required.'),
      block: yep
      .string()
      .required("Block is required.")
      .max(250, "Block should be less than 250 characters."),
      userName: yep
      .string()
      .required("Please Enter User Name.")
      .min(3, "User Name should be more than 3 characters.")
      .max(20, "User Name should be less than 20 characters.")
      .matches(
        /^[a-zA-Z0-9_]+$/,
        "User Name can only contain letters, numbers, and underscores."
      ),
      location: yep .string()
      .required("Location is required.")
  });



  //get-city-by-state
  const CityState = async (value) => {
    try {
      const res = await Axios({
        method: "GET",
        url: ApiConfig.getCityByState,
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
        },
        params: {
          stateName: value,
        },
      });

      if (res.data.status === 200) {
        setCityState(res?.data?.data);
      }
    } catch (error) { }
  };

  //get-state-country-wise
  const StateCountry = async (value) => {
    try {
      const res = await Axios({
        method: "GET",
        url: ApiConfig.getStateCountryWise,
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
        },
        params: {
          countryCode: value
        },
      });

      if (res.data.status === 200) {
        setStates(res?.data?.data);

        // console.log("countrywise",res?.data?.data)
      }
    } catch (error) { }
  };



  ///Head Officer List ///
  const AllHeadOfficerList = async (value) => {

    try {
      const res = await Axios({
        method: "GET",
        url: ApiConfig.headOfficer,
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
        },
        params: {

        },
      });
      if (res.data.status === 200) {
        setHeadOfficer(res?.data?.data);
      }
    } catch (error) {
    }
  };

  ///Branch Manager List ///
  const AllBranchManagerList = async (value) => {

    try {
      const res = await Axios({
        method: "GET",
        url: ApiConfig.branchManagerList,
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
        },
        params: {
          userId: hoID
        },
      });
      if (res.data.status === 200) {
        setBranchManagerList(res?.data?.data);
      }
    } catch (error) {
    }
  };

  ///Branch Head List///
  const AllBranchHeadList = async (value) => {
    try {
      const res = await Axios({
        method: "GET",
        url: ApiConfig.allBranchHeadList,
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
        },
        params: {
          userId: bmID
        },
      });
      if (res.data.status === 200) {
        setBranchHeadList(res?.data?.data);
      }
    } catch (error) {
    }
  };

  useEffect(() => {
    AllHeadOfficerList();
    // AllBranchManagerList();
    // AllBranchHeadList();
  }, []);
  useEffect(() => {

    AllBranchHeadList();
  }, [bmID]);
  useEffect(() => {

    AllBranchManagerList();

  }, [hoID]);
  const onChangeHandler = (data, type) => {
    // Your implementation for onChangeHandler
    console.log(data)
    const long = data?.eventLongitude
    const lat = data?.eventLatitude
    const location = data?.eventAddress
    setUserLocation(JSON.stringify({ location: location }))
  };
  useEffect(() => {
    StateCountry("IN");
  }, []);

  useEffect(() => {
    CityState(showStates);
  }, [showStates]);
  return (
    <>
      <PageTitle title="Add tester" />
      <Formik
        onSubmit={(values) => handleFormSubmit(values)}
        initialValues={formInitialSchema}
        initialStatus={{
          success: false,
          successMsg: "",
        }}
        validationSchema={validationSchema}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          touched,
          handleFocus,
          values,
          setFieldValue,
        }) => (
          <Form>
            <Container maxWidth="xl">
              <Grid container spacing={4}>
                {/* Image Upload Section */}
                <Grid item lg={4} md={12}>
                  <Card className={classes.imageUploadCard}>
                    <CardContent>
                      <Typography variant="h6" className={classes.sectionTitle}>
                        Profile Image
                      </Typography>
                      <Box className={
                        imgLink == '' ? classes.colorbox : classes.colorbox1
                      }>
                        <DropzoneArea 
                          classes={classes.DropzoneArea}
                          acceptedFiles={['image/*']}
                          maxFileSize={5000000}
                          filesLimit={1}
                          onDelete={() => {
                            setImage('');
                            setImgLink('');
                            toast.success("Image deleted successfully");
                          }}
                          onDrop={handleDrop}
                        />
                        {loader1 && (
                          <CircularProgress 
                            style={{ 
                              position: 'absolute', 
                              top: '50%', 
                              left: '50%', 
                              transform: 'translate(-50%, -50%)',
                              zIndex: '20' 
                            }} 
                          />
                        )}
                      </Box>
                      <Typography variant="body2" style={{ 
                        marginTop: "16px", 
                        color: "#6c757d",
                        fontSize: "14px"
                      }}>
                        Upload a clear profile photo (Max 5MB)
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Form Sections */}
                <Grid item lg={8} md={12}>
                  {/* Basic Details Section */}
                  <Card className={classes.formCard}>
                    <CardContent className={classes.formCardContent}>
                      <Typography className={classes.sectionTitle}>
                        Basic Details
                      </Typography>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                          <Box className={classes.faq}>
                            <label className={classes.label}>
                              Full Name <span style={{ color: "red" }}>*</span>
                            </label>
                            <TextField
                              placeholder="Please enter full name"
                              type="text"
                              variant="outlined"
                              fullWidth
                              size="small"
                              name="fullName"
                              autoComplete="off"
                              value={values.fullName}
                              onBlur={handleBlur}
                              error={touched.fullName && !!errors.fullName}
                              className={classes.TextBox}
                              onChange={handleChange}
                            />
                            <FormHelperText
                              error
                              style={{ fontSize: "12px", fontFamily: "Poppins" }}
                            >
                              {touched.fullName && errors.fullName}
                            </FormHelperText>
                          </Box>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <Box className={classes.faq}>
                            <label className={classes.label}>
                              Email <span style={{ color: "red" }}>*</span>
                            </label>
                            <TextField
                              placeholder="Please enter email address"
                              type="email"
                              variant="outlined"
                              size="small"
                              fullWidth
                              name="email"
                              value={values.email}
                              onBlur={handleBlur}
                              error={touched.email && !!errors.email}
                              className={classes.TextBox}
                              onChange={(e) => setFieldValue("email", e.target.value.toLowerCase())}
                            />
                            <FormHelperText
                              error
                              style={{ fontSize: "12px", fontFamily: "Poppins" }}
                            >
                              {touched.email && errors.email}
                            </FormHelperText>
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Box className={classes.faq}>
                            <label className={classes.label}>
                              Username <span style={{ color: "red" }}>*</span>
                            </label>
                            <TextField
                              placeholder="Please enter user name"
                              type="text"
                              variant="outlined"
                              size="small"
                              fullWidth
                              name="userName"
                              value={values.userName}
                              onBlur={handleBlur}
                              error={touched.userName && !!errors.userName}
                              className={classes.TextBox}
                              onChange={handleChange}
                            />
                            <FormHelperText
                              error
                              style={{ fontSize: "12px", fontFamily: "Poppins" }}
                            >
                              {touched.userName && errors.userName}
                            </FormHelperText>
                          </Box>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth>
                            <Box style={{ width: "100%" }}>
                              <label className={classes.label}>
                                Phone Number <span style={{ color: "red" }}>*</span>
                              </label>
                              <PhoneInput
                                country={"in"}
                                inputStyle={{
                                  background: "transparent",
                                  width: "100%",
                                  color: "#000",
                                  backgroundColor: 'white',
                                  paddingLeft: "48px !important",
                                  marginTop: "5px",
                                  borderRadius: "12px",
                                  border: "1px solid #ccc",
                                  height: "40px",
                                }}
                                value={values.phoneNumber}
                                error={Boolean(touched.phoneNumber && errors.phoneNumber)}
                                onBlur={handleBlur}
                                onChange={(mobile, e) => {
                                  setCountryCode(e.dialCode);
                                  setFieldValue("phoneNumber", mobile);
                                }}
                                className={`textFeilds textHeight ${classes.selectedFlag}`}
                                InputProps={{
                                  className: classes.TextBox,
                                }}
                              />
                            </Box>
                          </FormControl>
                          <FormHelperText
                            error
                            style={{
                              fontSize: "12px",
                              fontFamily: "Poppins",
                            }}
                          >
                            {touched.phoneNumber && errors.phoneNumber}
                          </FormHelperText>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <label className={classes.label}>
                            State <span style={{ color: "red" }}>*</span>
                          </label>
                          <FormControl
                            variant="outlined"
                            fullWidth
                            className={classes.select}
                          >
                            <Select
                              MenuProps={menuProps}
                              fullWidth
                              name="state"
                              margin="dense"
                              value={values.state}
                              error={Boolean(touched.state && errors.state)}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                setShowStates(e.target.value)
                                handleChange(e);
                              }}
                              displayEmpty
                              style={{ background: "white" }}
                            >
                              <MenuItem value="">
                                <Typography style={{ color: "rgba(0, 0, 0, 0.4)" }}>Select State</Typography> 
                              </MenuItem>
                              {states?.length !== 0 &&
                                states?.map((state) => {
                                  return (
                                    <MenuItem
                                      key={state?.stateName + state?.stateId}
                                      value={state?.stateName}
                                    >
                                      {state?.stateName}
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                          <FormHelperText
                            error
                            style={{ fontSize: "12px", fontFamily: "Poppins" }}
                          >
                            {touched.state && errors.state}
                          </FormHelperText>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <label className={classes.label}>
                            City <span style={{ color: "red" }}>*</span>
                          </label>
                          <FormControl
                            variant="outlined"
                            fullWidth
                            className={classes.select}
                          >
                            <Select
                              MenuProps={menuProps}
                              placeholder="Enter your city"
                              margin="dense"
                              name="city"
                              value={values.city}
                              error={Boolean(touched.city && errors.city)}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                handleChange(e);
                              }}
                              displayEmpty
                              style={{ background: "white" }}
                            >
                              <MenuItem value="">
                                <Typography style={{ color: "rgba(0, 0, 0, 0.4)" }}>Select City</Typography> 
                              </MenuItem>
                              {citystate.map((city) => {
                                return (
                                  <MenuItem
                                    key={city.name + city.id}
                                    value={city.name}
                                  >
                                    {city.name}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                          <FormHelperText error style={{ fontSize: "12px", fontFamily: "Poppins" }}>
                            {touched.city && errors.city}
                          </FormHelperText>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Box className={classes.faq}>
                            <label className={classes.label}>
                              Block <span style={{ color: "red" }}>*</span>
                            </label>
                            <TextField
                              InputProps={{ maxLength: 256 }}
                              placeholder="Please enter block"
                              type="text"
                              variant="outlined"
                              fullWidth
                              size="small"
                              name="block"
                              value={values.block}
                              onBlur={handleBlur}
                              error={touched.block && !!errors.block}
                              className={classes.TextBox}
                              onChange={handleChange}
                            />
                          </Box>
                          <FormHelperText
                            error
                            style={{ fontSize: "12px", fontFamily: "Poppins" }}
                          >
                            {touched.block && errors.block}
                          </FormHelperText>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <Box className={classes.faq}>
                            <label className={classes.label}>
                              Location <span style={{ color: "red" }}>*</span>
                            </label>
                            <ReactGoogleAutocomplete
                              apiKey="AIzaSyCzU4XQ6D43-mEnHWZ5l3vobePxE6p2GRw"
                              onPlaceSelected={(place) => {
                                const lat = place?.geometry?.location.lat();
                                const lng = place?.geometry?.location.lng();
                                onChangeHandler(
                                  {
                                    eventAddress: place?.formatted_address,
                                    eventLatitude: lat,
                                    eventLongitude: lng,
                                  },
                                  "Address"
                                );
                              }}
                              options={""}
                              onFocus={handleFocus}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              name="location"
                              style={{
                                width: '100%',
                                height: '40px',
                                padding: "12px",
                                borderRadius: "12px",
                                border: '1px solid #ccc',
                                fontSize: "16px",
                                backgroundColor: 'white'
                              }}
                            />
                          </Box>
                          <FormHelperText
                            error
                            style={{ fontSize: "12px", fontFamily: "Poppins" }}
                          >
                            {touched.location && errors.location}
                          </FormHelperText>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>

                  {/* Branch Details Section */}
                  <Card className={classes.formCard}>
                    <CardContent className={classes.formCardContent}>
                      <Typography className={classes.sectionTitle}>
                        Branch Details
                      </Typography>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                          <label className={classes.label}>
                            Administrator <span style={{ color: "red" }}>*</span>
                          </label>
                          <FormControl
                            variant="outlined"
                            fullWidth
                            className={classes.select}
                          >
                            <Select
                              MenuProps={menuProps}
                              margin="dense"
                              name="ho"
                              className={classes.selectTag}
                              value={values.ho}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                handleChange(e)
                              }}
                              displayEmpty
                              style={{ background: "white" }}
                            >
                              <MenuItem value="">
                                <Typography style={{ color: "rgba(0, 0, 0, 0.4)" }}>Select Administrator</Typography>
                              </MenuItem>
                              {headOfficer.map((user, datakey) => {
                                return (
                                  <MenuItem
                                    key={datakey}
                                    value={user.fullName}
                                    onClick={() => {
                                      setHoID(user.userId)
                                    }}
                                  >
                                    {user.fullName}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                          <FormHelperText error style={{ fontSize: "12px", fontFamily: "Poppins" }}>
                            {touched.ho && errors.ho}
                          </FormHelperText>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <label className={classes.label}>
                            Regional Manager <span style={{ color: "red" }}>*</span>
                          </label>
                          <FormControl
                            variant="outlined"
                            fullWidth
                            className={classes.select}
                          >
                            <Select
                              MenuProps={menuProps}
                              margin="dense"
                              name="branchManager"
                              value={values.branchManager}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                handleChange(e);
                              }}
                              displayEmpty  
                              style={{ background: "white" }}
                            >
                              <MenuItem value="">
                                <Typography style={{ color: "rgba(0, 0, 0, 0.4)" }}>Select Regional Manager</Typography> 
                              </MenuItem>
                              {branchManagerList.map((user) => {
                                return (
                                  <MenuItem
                                    key={user.fullName}
                                    value={user.fullName}
                                    onClick={() => {
                                      setBmID(user.userId)
                                    }}
                                  >
                                    {user.fullName}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                          <FormHelperText error style={{ fontSize: "12px", fontFamily: "Poppins" }}>
                            {touched.branchManager && errors.branchManager}
                          </FormHelperText>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <label className={classes.label}>
                            Area Manager <span style={{ color: "red" }}>*</span>
                          </label>
                          <FormControl
                            variant="outlined"
                            fullWidth
                            className={classes.select}
                          >
                            <Select
                              MenuProps={menuProps}
                              margin="dense"
                              name="branchHead"
                              value={values.branchHead}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                handleChange(e);
                              }}
                              displayEmpty
                              style={{ background: "white" }}
                            >
                              <MenuItem value="">
                                <Typography style={{ color: "rgba(0, 0, 0, 0.4)" }}>Select Area Manager</Typography> 
                              </MenuItem>
                              {branchHeadList.map((user) => {
                                return (
                                  <MenuItem
                                    key={user.fullName}
                                    value={user.fullName}
                                    onClick={() => {
                                      setBhID(user.userId)
                                    }}
                                  >
                                    {user.fullName}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                          <FormHelperText error style={{ fontSize: "12px", fontFamily: "Poppins" }}>
                            {touched.branchHead && errors.branchHead}
                          </FormHelperText>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>

                  {/* Action Buttons */}
                  <Box className={classes.buttonContainer}>
                    <Button
                      type="submit"
                      variant="contained"
                      className={classes.tableButton}
                      disabled={loader}
                      size="large"
                    >
                      {loader ? (
                        <CircularProgress size={24} color="inherit" />
                      ) : (
                        "Add Tester"
                      )}
                    </Button>
                    <Button
                      variant="outlined"
                      className={classes.tableButton}
                      onClick={() => history.push('/app/user-list')}
                      size="large"
                      style={{
                        background: "transparent",
                        border: "2px solid #00AFEE",
                        color: "#00AFEE",
                        '&:hover': {
                          background: "#00AFEE",
                          color: "white",
                        }
                      }}
                    >
                      Back
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Container>
          </Form>
        )}
      </Formik >
    </>
  );
}
export default Addtester;
